import React from 'react';

const FUELS = [
  { key: 'vlsfo',  label: 'VLSFO',  sub: '0.5%' },
  { key: 'mgo',    label: 'MGO',    sub: '0.1%' },
  { key: 'ifo380', label: 'IFO380', sub: '3.5%' },
];

/**
 * mode='single'  → one active at a time (default)
 * mode='double'  → up to 2 active (mobile table)
 */
export default function FuelSelector({ selected, onChange, mode = 'single' }) {
  const active = Array.isArray(selected) ? selected : [selected];

  const toggle = (key) => {
    if (mode === 'single') { onChange(key); return; }
    if (active.includes(key)) {
      if (active.length > 1) onChange(active.filter(f => f !== key));
    } else {
      onChange(active.length >= 2 ? [...active.slice(1), key] : [...active, key]);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {FUELS.map(f => {
        const isActive = active.includes(f.key);
        return (
          <button
            key={f.key}
            onClick={() => toggle(f.key)}
            style={{
              padding: '5px 12px',
              borderRadius: 6,
              border: `1px solid ${isActive ? '#e9a020' : '#1e2d44'}`,
              background: isActive ? 'rgba(233,160,32,0.10)' : 'transparent',
              color: isActive ? '#e9a020' : '#8892a5',
              fontSize: 12, fontWeight: 600,
              cursor: 'pointer',
              fontFamily: "'JetBrains Mono', monospace",
              transition: 'all 0.15s',
            }}
          >
            {f.label}
            {f.sub && <span style={{ fontSize: 10, marginLeft: 3, opacity: 0.7 }}>{f.sub}</span>}
          </button>
        );
      })}
    </div>
  );
}
